import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

// svg
import { ReactComponent as IconClose } from "../../assets/svg/close.svg";
import { ReactComponent as IconInformation } from "../../assets/svg/information.svg";
import { Box } from "@mui/material";

const CustomizedDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "680px",
    borderRadius: "16px",
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  "& .MuiDialogTitle-root": {
    background: "#343745",
    color: "#efa21e",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
    justifyContent: "center",
  },
}));

export const TutorialPopup = ({
  open,
  handleClose,
  title,
  children,
  hideHint,
  isHintHidden,
}) => {
  return (
    <CustomizedDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              width: "28px",
              height: "28px",
              background: "rgba(239, 162, 30, 0.1)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconInformation width="20px" height="20px" fill="#efa21e" />{" "}
          </Box>
          {title}
        </Box>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 16,
          color: theme.palette.grey[500],
        })}
      >
        <IconClose width="16px" height="16px" stroke="#efa21e" />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      {isHintHidden ? null : (
        <DialogActions>
          <Button
            autoFocus
            onClick={hideHint}
            sx={{
              textTransform: "none",
              /* background: "#fff",
            color: "#343745",
            boxShadow: 2,
            ":hover": {
              boxShadow: 4,
            }, */
            }}
          >
            Don't show this hint by default
          </Button>
        </DialogActions>
      )}
    </CustomizedDialog>
  );
};
